import * as React from 'react';
import * as Styled from './FooterBase.styled';

export function FooterBase(
  // eslint-disable-next-line @typescript-eslint/ban-types
  props: React.PropsWithChildren<{}>
): React.ReactElement | null {
  return <Styled.FooterBaseRoot>{props.children}</Styled.FooterBaseRoot>;
}
